:host {
  display: block;
}

#container {
  width: 200px;
  text-align: left;
  padding: var(--spacer-2);
}

#container img {
  margin-bottom: var(--spacer-2);
  width: 100%;
}

#container .title {
  font-size: var(--font-size-100);
  font-weight: 600;
  color: var(--aha-gray-900);
  margin-bottom: var(--spacer-2);
}

#container .description {
  font-size: var(--default-font-size);
  color: var(--aha-gray-800);
  margin-bottom: var(--spacer-2);
  width: 85%;
}

#container .button-wrapper {
  display: flex;
  justify-content: flex-end;
}
